<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <strong>{{ caption }}</strong> 服务
      </div>
      <b-form @submit="onSubmit" @reset="onReset">
        <b-form-group label="服务名" label-for="service_code">
          <b-form-select
              id="service_code"  v-model="data.service_code"
              :options="services" :disabled="true">
          </b-form-select>
        </b-form-group>
        <b-form-group label-for="product_code" label="产品：">
          <el-select filterable id="product_code"
                     v-model="data.product_code">
            <el-option v-for="product in products" :key="product.code" :label="product.name"
                       :value="product.code"></el-option>
          </el-select>
        </b-form-group>
        <b-form-group label="实例名" label-for="name">
          <b-form-input id="name" type="text" v-model="data.name"
              required></b-form-input>
        </b-form-group>
        <b-form-group label="代号" label-for="code">
          <b-form-input id="code" type="text" v-model="data.code" placeholder="选填"
              :disabled="isUpdate"></b-form-input>
        </b-form-group>
        <b-form-group label="实例URL" label-for="index_url">
          <b-form-input id="index_url" type="text" v-model="data.index_url"></b-form-input>
        </b-form-group>
        <b-form-group label="上线时间" label-for="online_time">
          <el-date-picker v-model="data.online_time" id="online_time"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              type="date">
          </el-date-picker>
        </b-form-group>
        <b-form-group label="简介" label-for="desc">
          <b-form-textarea id="desc" rows="3" v-model="data.desc"
                           required ></b-form-textarea>
        </b-form-group>
        <b-form-group label="图片" label-for="img_url">
          <b-row class="mb-2"><b-col sm="2">
            <b-button @click="data.img_url.push('')" size="sm" class="mr-2" variant="outline-success">
              <span class="fa fa-plus"></span>
            </b-button>
            <b-button size="sm" class="mr-2" variant="outline-danger"
                      @click="data.img_url.splice(-1, 1)">
              <span class="fa fa-minus"></span>
            </b-button>
          </b-col></b-row>
          <b-form-row class="mb-2">
              <image-upload id="img_url" :fileObj.sync="data.img_url[i]" v-for="(img_url, i) in data.img_url" :key="i"></image-upload>
          </b-form-row>
        </b-form-group>
        <div slot="footer">
          <b-button type="submit" size="sm" variant="outline-primary"><i class="fa fa-check"></i> 提交</b-button>
          <b-button type="reset" size="sm" variant="outline-danger"><i class="fa fa-remove"></i> 返回</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'
import ImageUpload from '@/components/ImageUpload'

export default {
  name: 'service-create',
  mixins: [Error],
  components: {
    ImageUpload
  },
  data () {
    return {
      data: {
        title: '',
        code: '',
        index_url: '',
        online_time: '',
        service_code: this.$route.params.serviceCode,
        product_code: '',
        icon_url: '',
        desc: '',
        img_url: []
      },
      service_types: consts.SERVICE_TYPES,
      category_types: consts.CATEGORY_TYPES,
      products: [],
      services: {}
    }
  },
  computed: {
    serviceCode: function () {
      return this.$route.params.serviceCode
    },
    // eslint-disable-next-line
    isUpdate: function () { return this.$route.params.demoCode ? true : false },
    caption: function () { return this.isUpdate ? '更新' : '创建' }
  },
  created () {
    this.$ajax.all([
      this.$ajax.get(api.getProductList()),
      this.$ajax.get(api.getServiceList())
    ]).then(([productdata, serviceData]) => {
      this.products.push({
        code: null, name: '请选择', disabled: true
      })
      productdata.products.forEach((product) => {
        this.products.push({code: product.code, name: product.name})
      })
      this.services = {}
      serviceData.services.forEach((service) => {
        this.services[service.code] = service.name
      })
    })
    if (this.isUpdate) {
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      this.$ajax.all([
        this.$ajax.get(api.getDemoDetail(
          this.$route.params.serviceCode, this.$route.params.demoCode
        ))
      ]).then(([demoData]) => {
        this.data = demoData.demo
      }, (res) => {
        this.handleError(res)
      })
    },
    onSubmit (evt) {
      evt.preventDefault()
      if (this.isUpdate) {
        api.updateData(this, api.getDemoDetail(
          this.$route.params.serviceCode, this.$route.params.demoCode
        ), this.data)
      } else {
        api.createData(this, api.getDemoCreate(this.serviceCode), this.data, 'demo-list')
      }
    },
    onReset (evt) {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// DemoCreate.vue?6f664e6a